// Recursivly converts chart lines to the vector format required by recharts data model
export var linesToData = function (chartLines) {
    if (chartLines.length === 1) {
        var line_1 = chartLines[0];
        return line_1.values.map(function (val) {
            var _a;
            return (_a = { x: val.x }, _a[line_1.id] = val.y, _a);
        });
    }
    else if (chartLines.length === 0) {
        return [];
    }
    else {
        var partialRes = linesToData(chartLines.slice(1));
        var remainingLine_1 = chartLines[0];
        var res = partialRes.map(function (item) {
            var newItem = item;
            var maybeValue = remainingLine_1.values.find(function (v) { return v.x === item.x; });
            if (maybeValue) {
                newItem[remainingLine_1.id] = maybeValue.y;
            }
            return newItem;
        });
        return res;
    }
};
//# sourceMappingURL=lines-to-data.js.map